import { Bell, Search } from 'lucide-react';
import UserDropdown from './UserDropdown';
import logo from '../../assets/logos/saccos_logo.png';

export default function TopNavbar() {
  return (
    <header className="h-20 bg-white shadow-sm flex items-center justify-between px-6 z-10">
      <div className="flex items-center lg:hidden">
        <img src={logo} alt="Uhamiaji SACCOS" className="h-8 w-auto" />
      </div>

      <div className="hidden lg:flex items-center flex-1">
        <div className="relative w-full max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-brand-navy/30" />
          <input
            type="text"
            placeholder="Search..."
            className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg text-[15px] bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brand-gold focus:border-brand-gold focus:bg-white transition-colors"
          />
        </div>
      </div>

      <div className="flex items-center space-x-4">
        <button className="relative p-2 text-brand-navy/60 hover:text-brand-gold transition-colors">
          <Bell className="w-5 h-5" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" />
        </button>

        <UserDropdown />
      </div>
    </header>
  );
}
